import auth from '@/mixins/auth'
import throttle from 'lodash/throttle'
import imageProxy from '@/libs/image-proxy'
import utmTracking from '@/mixins/utm-tracking'
import visibility from '@/mixins/visibility'
import UserAvatar from '@/components/Controls/UserAvatar'
import breakpoints from '@/libs/breakpoints'

const tvCategoryID = 266

export default {
  components: {
    UserAvatar
  },
  mixins: [auth, utmTracking, visibility],
  data: function () {
    return {
      str: '',
      likeUpdate: 1,
      image: { loading: false, loaded: false, error: false },
      visibilityConfig: { options: { rootMargin: '100px' } }
    }
  },
  mounted: function () {
    // TODO: This fetchMembers is extremely inefficient and slow, disable it for judging
    /*
    if (this.project && this.displayType !== 'registrationForm' && this.displayType !== 'judgeTeam' && this.displayType !== 'teamProject') {
      this.fetchMembers()
    } */
  },
  computed: {
    isBlank: function () {
      return this.projectID < 0 || this.isRowLoading
    },
    isGame: function () {
      if (this.$isEngCom) {
        for (let i = 0; i < this.project.categories.length; i++) {
          if (this.project.categories[i].id === 60) {
            return true
          }
        }
      }
      return false
    },
    pathExtra: function () {
      const rec = []
      if (this.recommendationSource) {
        rec.push(this.recommendationSource)
      }

      if (this.recommendationType) {
        rec.push(this.recommendationType)
      }

      if (rec.length > 0) {
        return `?rec=${btoa(rec.join('|'))}`
      }

      return ''
    },
    hasLiked: function () {
      return this.isLoggedIn && this.likeUpdate > 0 ? this.$store.getters.likedProject(this.project.id, this.currentUser.userName) : false
    },
    description: function () {
      return (this.project && this.project.description) ? this.project.description : ''
    },
    hideCategory: function () {
      return this.selectedCategory && (!this.selectedCategory.subCategories || this.selectedCategory.subCategories.length <= 0)
    },
    selectedCategory: function () {
      return this.categoryID > 0 ? this.$store.getters.categoryByID(this.categoryID) : null
    },
    displayCategory: function () {
      if (!this.hasCategories) {
        return ''
      }

      if (this.selectedCategory && this.project.categories.length > 1) {
        const isParent = this.selectedCategory.parentID === 0

        for (let i = 0; i < this.project.categories.length; i++) {
          if (isParent && this.project.categories[i].parentID === this.selectedCategory.id) {
            return this.project.categories[i]
          }

          if (this.project.categories[i].id === this.selectedCategory.id) {
            return this.project.categories[i]
          }
        }
      }

      return this.project.categories[0]
    },
    hasCategories: function () {
      return this.project && this.project.categories && this.project.categories.length > 0
    },
    imageBackground: function () {
      if (this.isBlank) {
        return
      }

      const style = {}

      if (this.project.imageUrl) {
        if (this.image.loaded) {
          if (this.isGame) {
            style.backgroundImage = `url('${imageProxy.gameCard(this.project.imageUrl)}')`
          } else {
            if (this.$isIsef) {
              style.backgroundImage = `url('${imageProxy.autoFocusProjectCard(this.project.imageUrl)}')`
            } else {
              style.backgroundImage = `url('${imageProxy.projectCard(this.project.imageUrl)}')`
            }
          }
        } else if (this.image.error) {
          style.backgroundImage = `url('${imageProxy.projectCard('/static/boardTypes/project-gradient.svg')}')`
        }
      } else {
        style.backgroundImage = `url('${imageProxy.projectCard('/static/boardTypes/project-gradient.svg')}')`
      }

      return style
    },
    imageOverlay: function () {
      if (this.isBlank) {
        return
      }

      const style = {}

      if (this.project.image) {
        if (this.image.loaded) {
          style.backgroundImage = `url('${imageProxy.imageOverlay(this.project.imageUrl)}')`
        } else if (this.image.error) {
          style.backgroundImage = `url('${imageProxy.imageOverlay('/static/boardTypes/project-gradient.svg')}')`
        }
      }

      return style
    },
    title: function () {
      return this.project.title
    },
    route: function () {
      return this.$route
    },
    canView: function () {
      return this.project.isLocked && !this.isLoggedIn && this.$isStories
    },
    elementID: function () {
      return `project-${this.projectID}-${this._uid}`
    },
    author: function () {
      return this.project.user && this.project.user.fullName ? this.project.user.fullName : this.formattedUsername
    },
    formattedUsername: function () {
      if (!this.project.user) {
        return
      }
      let username = this.project.user.userName
      if (username.length > 16) {
        username = `${username.substring(0, 16)}...`
      }
      return username
    },
    project: function () {
      if (this.isGroupProject) {
        return this.projectID > 0 ? this.$store.getters.getGroupProjects[this.projectID] : {}
      }
      if (this.displayType === 'registrationForm') {
        return this.projectID > 0 ? this.$store.getters.getJudgingProjectById(this.projectID) : {}
      } else if (this.displayType === 'judgeTeam') {
        return this.projectID > 0 ? this.$store.getters.getJudgingTeam(this.projectID) : {}
      } else if (this.displayType === 'teamProject') {
        return this.projectID > 0 ? this.$store.getters.project(this.projectID) : {}
      }

      return this.projectID > 0 ? this.$store.getters.project(this.projectID) : {}
    },
    path: function () {
      if (this.fromSearch) {
        return `/project/${this.projectID}`
      }

      if (this.disableLink) {
        return '#'
      }
      if (!this.project) {
        return ''
      }
      if (this.project && this.project.booth) {
        if (this.project.booth.slug && (this.$isIsef || this.$isBroadcomMasters || this.$isSts)) {
          if (this.project.booth.id_in_url) {
            return `/${this.project.booth.slug}/${this.projectID}`
          } else {
            return `/${this.project.booth.slug}`
          }
        }
        if (this.project.booth.slug && this.project.booth.slug === 'expobooth') {
          return `/${this.project.booth.slug}/${this.projectID}`
        }
      }
      if (this.isBlank || (this.project.url && this.project.url !== '') || (!this.$isEngCom && this.project.type === 'story')) {
        return ''
      }
      if (this.isTvCategory && this.$isEngCom) {
        return { path: `${this.basePath}/${this.project.slug}`, query: { fromID: this.categoryID } }
      }
      if (!this.project.slug) {
        return `${this.basePath}/${this.projectID}`
      }
      if (this.storyType) {
        return `${this.basePath}/${this.project.slug}?newest=true`
      }
      return `${this.basePath}/${this.project.slug}`
    },
    basePath: function () {
      return this.$isEngCom ? '/story' : '/project'
    },
    categoryName: function () {
      const category = this.$store.getters.categoryByID(this.categoryID) || this.$store.getters.categoryBySlug(this.displayCategory.slug)
      if (category) {
        return category.name
      }
    },
    spaceBetweenAwards: function () {
      return 20
    },
    isMobile: function () {
      return breakpoints.isMobile()
    },
    isTvCategory: function () {
      if (this.$isEngCom && this.project.categories !== null) {
        return !!this.project.categories.find(category => category.parentID === tvCategoryID)
      } else {
        return null
      }
    },
    members: function () {
      return this.projectID > 0 ? this.$store.getters.projectMembers(this.projectID) : {}
    },
    coOwners: function () {
      return this.members ? this.members.filter(m => ['co-owner', 'owner'].includes(m.role)) : []
    },
    isOASJudge: function () {
      return this.$isOhioScience && this.currentUser.type.includes('judge')
    }
  },
  methods: {
    emitClick: function () {
      if (!this.$isEngCom && this.project.type === 'story') {
        window.open('https://engineering.com/story/' + this.project.id)
      } else if (this.isGame) {
        window.open('https://engineering.com/story/' + this.project.id)
      } else if (this.project.url && this.project.url !== '') {
        window.open(this.getUTMLink(this.project.url, 'projects'))
      } else if (!this.disableClick) {
        this.$emit('click')
      }
    },
    canLike: function (event) {
      event.stopPropagation() // prevent showing
      if (!this.isLoggedIn) {
        return this.$store.dispatch('showLoginModal', { source: 'homepagelike:' + this.project.id, onSuccess: this.like, signupMessage: 'To like this project' })
      }
      this.like()
    },
    like: throttle(function () {
      let hasLiked = false
      const data = {
        id: this.project.id,
        username: this.currentUser.userName
      }

      this.$store.dispatch('likedProject', data).then((response) => {
        hasLiked = response
        if (hasLiked) {
          this.$store.dispatch('unlikeProject', data).then(() => { this.likeUpdate++ })
        } else {
          this.$store.dispatch('likeProject', data).then(() => { this.likeUpdate++ })
        }
      })
    }, 1000),
    goToUser: function (username) {
      this.$router.push({ name: 'profile', params: { username } })
    },
    onVisible: function () {
      if (this.image) {
        if (this.image.loading || this.image.loaded || this.isBlank) {
          return
        }

        // load project image once we're visible
        this.image.loading = true
        const image = new Image()
        image.onload = () => { this.image.loading = false; this.image.loaded = true }
        image.onerror = () => { this.image.loading = false; this.image.error = true }

        if (this.project?.imageUrl) {
          image.src = imageProxy.projectCard(this.project.imageUrl)
        } else {
          image.src = null
        }
      }
    },
    loggedOutSubscribe: function () {
      this.$store.dispatch('isSubscribedToProject', { id: this.projectID, username: this.currentUser.userName }).then((isSubbed) => {
        if (!isSubbed) {
          this.$store.dispatch('subscribeToProject', this.params).then(() => {
            this.goToBookmarks()
          })
        } else {
          this.goToBookmarks()
        }
      })
    },
    goToBookmarks: function () {
      this._set('navValue', 'following')
      this.$router.push({ name: 'home' })
    },
    toolTipSize: function (title) {
      if (title.length > 10) {
        return 'medium'
      }
      return 'small'
    },
    showBalloon: function (action, success) {
      const isPin = (action === 'Pin')
      let pinContent = ''

      if (success) {
        if (this.$isHeise) {
          pinContent = this.$t('story-header.pin.project')
          action = isPin ? pinContent : 'Gemerkt'
        } else {
          action = isPin ? `Pinned ${this.project.type}` : 'Bookmarked'
        }
      }
      if (!this.isMobile) {
        if (this.$isHeise) {
          switch (this.project.type && this.project) {
            case 'discussion':
              return success ? action : (action === 'Pin'
                ? this.$t('story-header.pin.this-project')
                : this.$t('story-header.bookmark.project')
              )
            case 'project':
              return success ? action : (action === 'Pin'
                ? this.$t('story-header.pin.this-project')
                : this.$t('story-header.bookmark.project')
              )
            default:
              return success ? action : (action === 'Pin'
                ? this.$t('story-header.pin.this-project')
                : this.$t('story-header.bookmark.project')
              )
          }
        }
        return success ? action : `${action} this ${this.project.type}`
      }
    },
    fetchMembers: function () {
      if (!this.project || !this.project.id) {
        return
      }
      this.$store.dispatch('getMembers', { project: this.project, limit: 10, offset: 0 }).then((response) => {
        this.members.push.apply(this.members, response.members)
        this.filterMembersOwners()
      })
    },
    filterMembersOwners: function () {
      this.members = this.members.map(function (users) {
        if (users.role === 'co-owner' || users.role === 'owner') {
          return users.user
        }
      })
      this.members = this.members.filter(function (users) {
        if (users !== undefined) {
          return users
        }
      })
      this.coOwners = this.members
    },
    isTooltipNeeded: function (tooltipContent) {
      const category = this.$refs.categoryRef
      if (this.$isEngCom && (category && (category.scrollHeight > category.clientHeight || category.scrollWidth > category.clientWidth))) {
        return tooltipContent
      } else {
        return false
      }
    }
  }
}
